interface Props {
  url: string;
  name?: string;
  lowerText?: string;
  imageUrl?: string;
}

export const ProfileChip: React.FC<Props> = ({
  url,
  name,
  lowerText,
  imageUrl,
}) => {
  return (
    <a href={url} className="button secondary profile-chip">
      {imageUrl && (
        <img src={imageUrl} alt={`Profilbilde for ${name}`} loading="lazy" />
      )}
      <div>
        {name && <div className="h2">{name}</div>}
        {lowerText && <div className="h4">{lowerText}</div>}
      </div>
    </a>
  );
};
